import {createRouter, createWebHistory, RouteLocationNormalized, Router, RouteRecordRaw} from 'vue-router'
import LoginView from '../views/LoginView.vue'
import {useAuthStore} from '@/stores/auth.store'
import {routes as adminRoutes} from "@/router/admin.routes";
import {routes as studentRoutes} from "@/router/student.routes";
import {routes as contactPersonRoutes} from "@/router/contactPerson.routes";
import ResetPasswordView from "@/views/ResetPasswordView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/password_reset/:create?',
    name: 'password_reset',
    component: ResetPasswordView
  },
    ...adminRoutes,
    ...studentRoutes,
    ...contactPersonRoutes
]

const router: Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkExactActiveClass: 'router-active',
  routes
})

const publicRoutes = ['student_register', 'password_reset']

router.beforeEach(async (to: RouteLocationNormalized): Promise<string|undefined> => {
  const authStore = useAuthStore()
  if(!publicRoutes.includes(to.name as string)) {
    if (to.name === 'login' || to.name === 'admin_login') {
      if (authStore.isLoggedIn && authStore.getUser?.roles?.includes('ROLE_ADMIN')) return Promise.resolve('/admin')
      else if (authStore.isLoggedIn && authStore.getUser?.roles?.includes('ROLE_STUDENT')) return Promise.resolve('/student')
      else if (authStore.isLoggedIn && authStore.getUser?.roles?.includes('ROLE_CONTACT_PERSON')) return Promise.resolve('/contact_person')
    } else {
      if (!authStore.isLoggedIn){
        if(to.fullPath && to.fullPath.toString().startsWith('/admin')) return Promise.resolve('/admin/login')
        else return Promise.resolve('/')
      }
      else{
        if(to.fullPath && to.fullPath.toString().startsWith('/admin') && !authStore.getUser?.roles?.includes('ROLE_ADMIN')) return Promise.resolve('/')
        if(to.fullPath && to.fullPath.toString().startsWith('/student') && !authStore.getUser?.roles?.includes('ROLE_STUDENT')) return Promise.resolve('/')
        if(to.fullPath && to.fullPath.toString().startsWith('/contact_person') && !authStore.getUser?.roles?.includes('ROLE_CONTACT_PERSON')) return Promise.resolve('/')
      }
    }
  }
})

router.onError((error) => {
  const chunkFailPatterns = [
    /Loading chunk (\d)+ failed/i,
    /ChunkLoadError/i,
    /dynamic import\(\) loading failed/i
  ]
  if (chunkFailPatterns.some((pattern) => pattern.test(error?.message ?? ''))) {
    // Force reload so the browser grabs the fresh chunk list that matches the deployed version
    window.location.reload()
  }
})

export default router
